<template>
  <card class="profile-card">
    <div>
      <div class="row profile-card__body">
        <div class="col-2" v-if="$slots.header">
          <slot name="header"></slot>
        </div>
        <div class="col-10" v-if="$slots.content">
          <slot name="content"></slot>
        </div>
      </div>
      <div v-if="$slots.footer">
        <hr />
        <slot name="footer"></slot>
      </div>
    </div>
  </card>
</template>
<script>
import { Card } from "@/components/index";

export default {
  name: "profile-card",
  components: {
    Card
  }
};
</script>
<style lang="scss">
.profile-card {
  cursor: pointer;

  .numbers {
    height: 100%;
  }

  transition: box-shadow 200ms ease-in-out;
  &:hover {
    box-shadow: 1px 2px 2px rgba(163, 157, 147, 0.5);
  }
}
</style>
